import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { UrlPrefixes } from "../../../shared/models/appData";
import { BrandCampaign } from "../../../shared/models/brandCampaign";
import { BrandInsightPartner } from "../../../shared/models/brandCampaignInsight";
import { cloneWith } from "../../../shared/services/clonable";
import { NotificationService } from "../../../shared/services/notification.service";
import { UrlFormatterService } from "../../../shared/services/url-formatter-service";
import { CustomFormValidators } from "../../../shared/validators/custom-form-validators";
import { BrandCampaignPartnersService } from "../shared/services/brand-campaign-partners.service";

export interface BrandCampaignPartnerEditDialogData {
  campaign: BrandCampaign;
  brandInsightPartner: BrandInsightPartner;
}

export type BrandCampaignPartnerEditDialogResult = BrandInsightPartner;

@Component({
  templateUrl: "./brand-campaign-partner-edit-dialog.component.html",
  styleUrls: ["./brand-campaign-partner-edit-dialog.component.scss"],
})
export class BrandCampaignPartnerEditDialogComponent {
  public readonly URL_VALIDATION_PATTERN =
    CustomFormValidators.URL_WITH_OBLIGATORY_NO_PROTOCOL_PATTERN;
  public campaign: BrandCampaign;
  public brandInsightPartner: BrandInsightPartner;
  public urlPrefixes = UrlPrefixes;
  public saving = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: BrandCampaignPartnerEditDialogData,
    public dialog: MatDialogRef<
      BrandCampaignPartnerEditDialogComponent,
      BrandCampaignPartnerEditDialogResult
    >,
    public urlFormatterService: UrlFormatterService,
    public notificationService: NotificationService,
    private brandCampaignPartnersService: BrandCampaignPartnersService,
  ) {
    this.campaign = cloneWith(data.campaign);
    this.brandInsightPartner = cloneWith(data.brandInsightPartner);
  }

  public saveBrandNotes(): void {
    this.saving = true;
    this.brandCampaignPartnersService
      .updateBrandCampaignPartner(
        this.campaign.id,
        this.brandInsightPartner.id,
        this.brandInsightPartner.brandNotes,
        this.brandInsightPartner.shortUrl,
        this.brandInsightPartner.shortUrlPrefix,
      )
      .subscribe({
        next: () => {
          this.dialog.close(this.brandInsightPartner);
        },
        error: () => {
          this.notificationService.error("shared.errorSavingChanges");
        },
        complete: () => {
          this.saving = false;
        },
      });
  }

  public formatShortUrl(): void {
    if (this.brandInsightPartner.shortUrl) {
      this.brandInsightPartner.shortUrl = this.urlFormatterService.formatUrl(
        this.brandInsightPartner.shortUrl,
      );
    }
  }
}
